// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.user-id,\n.el-table td.user-id {\n  width: 10em;\n}", ""]);
// Exports
module.exports = exports;
